/* istanbul ignore file */
import { useEffect } from "react";
import styles from "./RockAnim.module.scss";

type RockAnimParams = {
  /** Id of the element under this one */
  squashId: string;
};

export const RockAnim = ({ squashId }: RockAnimParams) => {
  const doIt = window.location.search.indexOf("ChadRocks") >= 0;
  useEffect(() => {
    if (doIt) {
      document.body.classList.add(styles.shake);
      document.getElementById(squashId)?.classList.add(styles.squash);
    }
  }, []);

  return (
    <>
      {doIt && (
        <div className={styles.container}>
          <span
            className={styles.rock}
            onClick={(e) => onClick(e.target as HTMLElement)}
          ></span>
        </div>
      )}
    </>
  );

  function onClick(e: HTMLElement): void {
    // Make Chad jump
    reanimateElement(e);
    // Rock the house
    reanimateElement(document.body as HTMLElement);
  }

  function reanimateElement(e: HTMLElement) {
    e.style.animation = "none";
    e.offsetHeight;
    e.style.animation = "";
    e.style.animationIterationCount = "1";
    e.style.animationDelay = "0s";
  }
};
